import axios from '@shared/axios-shared';

const sendFCMTokenToBackend = (token) => {
	return axios.post('api/v1/account/topic/subscribe', { device_token: token });
};

export { sendFCMTokenToBackend };
